import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SectionType } from '../../../shared/models/fact-find-api.model';
import { isCollectionSection } from '../../../shared/models/fact-find-collection.config';
import { slugToSectionType } from '../../../shared/utils/fact-find-routing/fact-find-routing.util';

export const collectionSectionGuard: CanActivateFn = (route) => {
  const router = inject(Router);

  const taskName = route.parent?.params['taskName'];

  if (!taskName) {
    return router.parseUrl('/fact-find/all');
  }

  const sectionType = slugToSectionType(taskName);
  if (sectionType === null) {
    return router.parseUrl('/fact-find/all');
  }

  const isCollection = isCollectionSection(sectionType);

  if (!isCollection) {
    if (sectionType === SectionType.Banking) {
      return router.parseUrl(`/fact-find/${taskName}/view-all-question`);
    }
    return router.parseUrl(`/fact-find/${taskName}/1`);
  }

  return true;
};
